/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.usagebasedbilling.experience.internal.rpc.UsageBasedBillingExperienceInternalRpc
 */

export const BasicBillableMetricTypeUsageTypename = 'com.hubspot.usagebasedbilling.experience.core.BasicBillableMetricTypeUsage';
export const DetailedBillableMetricTypeUsageTypename = 'com.hubspot.usagebasedbilling.experience.core.DetailedBillableMetricTypeUsage';
export let ComHubspotUsagebasedbillingExperienceCore;
(function (_ComHubspotUsagebasedbillingExperienceCore) {})(ComHubspotUsagebasedbillingExperienceCore || (ComHubspotUsagebasedbillingExperienceCore = {}));
export let ComHubspotUsagebasedbillingExperienceInternalRpcModels;
(function (_ComHubspotUsagebasedbillingExperienceInternalRpcModels) {})(ComHubspotUsagebasedbillingExperienceInternalRpcModels || (ComHubspotUsagebasedbillingExperienceInternalRpcModels = {}));
export const getUsagePeriodUsageRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.internal.rpc.UsageBasedBillingExperienceInternalRpc',
  rpcName: 'getUsagePeriodUsage',
  auth: 'internal',
  fingerprint: 'eAFvHEEr8AFPWaHxJN6XHjIeffvWuUtB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getHistoricalUsagePeriodUsageRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.internal.rpc.UsageBasedBillingExperienceInternalRpc',
  rpcName: 'getHistoricalUsagePeriodUsage',
  auth: 'internal',
  fingerprint: '0rmwHu0a19tzpEHY2ry6FDIeffvWuUtB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getHistoricalNonChargeableUsagePeriodUsageRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.internal.rpc.UsageBasedBillingExperienceInternalRpc',
  rpcName: 'getHistoricalNonChargeableUsagePeriodUsage',
  auth: 'internal',
  fingerprint: '0rmwHu0a19tA4xfCLH8IxjIeffvWuUtB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getHistoricalByFeatureCategoryRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.internal.rpc.UsageBasedBillingExperienceInternalRpc',
  rpcName: 'getHistoricalByFeatureCategory',
  auth: 'internal',
  fingerprint: 'oNp24VKVI9FF1diw-w6m9zIeffvWuUtB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getNonChargeableHistoricalByFeatureCategoryRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.internal.rpc.UsageBasedBillingExperienceInternalRpc',
  rpcName: 'getNonChargeableHistoricalByFeatureCategory',
  auth: 'internal',
  fingerprint: 'oNp24VKVI9FF1diw-w6m9zIeffvWuUtB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getHistoricalByBillableMetricTypeRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.internal.rpc.UsageBasedBillingExperienceInternalRpc',
  rpcName: 'getHistoricalByBillableMetricType',
  auth: 'internal',
  fingerprint: 'kEsJVlS6ADCBoIiQLAZ9NzIeffvWuUtB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAllBillableMetricChargingEligibilityRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.internal.rpc.UsageBasedBillingExperienceInternalRpc',
  rpcName: 'getAllBillableMetricChargingEligibility',
  auth: 'internal',
  fingerprint: 'xN2BknQLug8sJ8tSa4FGYzIeffvWuUtB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getRateCardRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.internal.rpc.UsageBasedBillingExperienceInternalRpc',
  rpcName: 'getRateCard',
  auth: 'internal',
  fingerprint: 'AAAAAAAAAAAch7bIS2-iqTIeffvWuUtB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};